import { Stack } from '@mui/material';
import { TaskChooser } from '@/components/logbook/task/TaskChooser';
import { useEffect, useState } from 'react';
import { getTasks } from '@/generated/client/driveon-api/driveon-api';
import { DriveOnDisplayableTaskDto as DriveOnTask } from '@/generated/model';
import { useTranslation } from 'react-i18next';

import './TaskList.css';

type TaskListProps = {
  setTask: (task: DriveOnTask) => void;
  enableSelect: boolean;
};

export function TaskList({ setTask, enableSelect }: TaskListProps) {
  const { t } = useTranslation();
  const [tasks, setTasks] = useState<DriveOnTask[] | undefined>();

  useEffect(() => {
    async function getTask() {
      const response = await getTasks().catch((error) => {
        setTasks(undefined);
        console.warn('getTask(): Api failed: getTasks -> ', error);
      });

      if (response && response.status == 200) {
        const data = response.data;
        setTasks(data);
        console.log('getTask(): Api called: getTasks');
      }
    }
    getTask();
  }, []);

  return (
    <div className="task-list">
      <Stack className="task-container" spacing={'0.5rem'}>
        {tasks && tasks?.length !== 0
          ? tasks.map((t) => (
              <TaskChooser
                key={t.eventusId}
                task={t}
                setTask={setTask}
                enableSelect={enableSelect}
                expanded={undefined}
                logbook={false}
              />
            ))
          : t('menetlevel.taskchooser.notask')}
      </Stack>
    </div>
  );
}
